/* OLD SOUL EXPERIENCE ENGINE™ V8.1 | Shared Commerce — V9 demand-load safe */
(function(){
  if(window.OldSoulV8CommerceLoaded)return;
  window.OldSoulV8CommerceLoaded=true;
  var key='oldSoulV8RecentlyViewed';

  document.addEventListener('click',function(e){
    var tab=e.target.closest('[data-v8-tab]');
    if(!tab)return;
    var root=tab.closest('[data-v8-tabs]');
    if(!root)return;
    root.querySelectorAll('[data-v8-tab]').forEach(function(b){b.setAttribute('aria-selected','false');});
    root.querySelectorAll('[data-v8-panel]').forEach(function(p){p.hidden=true;});
    tab.setAttribute('aria-selected','true');
    var panel=root.querySelector('#'+CSS.escape(tab.getAttribute('aria-controls')));
    if(panel)panel.hidden=false;
  });

  document.addEventListener('submit',function(e){
    var form=e.target.closest('[data-v8-shipping-form]');
    if(!form)return;
    e.preventDefault();
    var input=form.querySelector('input');
    var output=form.querySelector('[data-v8-shipping-output]');
    if(!input||!output)return;
    var zip=input.value.trim();
    output.textContent=zip?'Estimated delivery timing will be shown at checkout for '+zip+'.':'Enter a ZIP code to check delivery timing.';
  });

  function getList(){
    try{return JSON.parse(localStorage.getItem(key)||'[]');}catch(e){return [];}
  }

  function recordCurrentProduct(){
    if(!location.pathname.includes('/products/'))return;
    var item={url:location.pathname,title:(document.querySelector('h1')&&document.querySelector('h1').textContent.trim())||document.title,image:(document.querySelector('meta[property="og:image"]')&&document.querySelector('meta[property="og:image"]').content)||''};
    var list=getList().filter(function(x){return x.url!==item.url;});
    list.unshift(item);
    try{localStorage.setItem(key,JSON.stringify(list.slice(0,8)));}catch(e){}
  }

  function renderRecentlyViewed(root){
    var scope=root||document;
    scope.querySelectorAll('[data-v8-recently-viewed]').forEach(function(container){
      var limit=Number(container.dataset.limit||4);
      var list=getList().filter(function(x){return x.url!==location.pathname;}).slice(0,limit);
      if(!list.length){container.hidden=true;return;}
      var grid=container.querySelector('[data-v8-viewed-grid]');
      if(!grid)return;
      container.hidden=false;
      grid.innerHTML=list.map(function(x){return '<a class="old-soul-v8-viewed__item" href="'+x.url+'">'+(x.image?'<img loading="lazy" src="'+x.image+'" alt="">':'')+'<strong>'+x.title+'</strong></a>';}).join('');
    });
  }

  function init(root){recordCurrentProduct();renderRecentlyViewed(root||document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',function(event){renderRecentlyViewed(event.target);});
})();